export default __webpack_public_path__ + "static/pjatk-1cc5e6c4a584d4baf1bb7da3b6153833.svg";